import Component from '../core/Component';
import enquire from 'enquire.js';
import { queries } from '../core/config';

export default class Pillars extends Component {

    constructor($element) {
        super($element);
        this.$trigger = this.$element.find('[data-component-ref="trigger"]');
        this.$next = this.$element.find('[data-component-ref="next"]');
        this.$prev = this.$element.find('[data-component-ref="prev"]');
        this.$close = this.$element.find('[data-component-ref="close"]');
    }

    prepare() {

        enquire.register(queries.mediumUp, {
            match: ::this.attachMediumUp,
            unmatch: ::this.detachMediumUp
        });

        enquire.register(queries.smallMax, {
            match: ::this.attachMobile,
            unmatch: ::this.detachMobile
        });

        this.$next.on('click', event => {
            this.next();
        });

        this.$prev.on('click', event => {
            this.prev();
        });

    }

    attachMediumUp() {
        this.$trigger.on('click', event => {
            // $(event.currentTarget).closest('.pillar').addClass('is-active');
            $(event.currentTarget).closest('.pillar').find('.pillar__content').fadeIn(250, () => $(event.currentTarget).closest('.pillar').addClass('is-active'));
        });

        this.$close.on('click', event => {
            // $(event.currentTarget).closest('.pillar').removeClass('is-active');
            $(event.currentTarget).closest('.pillar').find('.pillar__content').fadeOut(250, () => $(event.currentTarget).closest('.pillar').removeClass('is-active'));
        });
    }

    detachMediumUp() {

    }

    next() {
        if (this.$element.find('.pillar.is-active').next() && this.$element.find('.pillar.is-active').next().length > 0) {
            const $active = this.$element.find('.pillar.is-active');
            $active.next().find('.pillar__content').fadeIn(250, () => {
                $active.next().addClass('is-active');
            });
            $active.next().siblings().find('.pillar__content').fadeOut(250, () => {
                $active.next().siblings().removeClass('is-active');
            });
        } else {
            this.$element.find('.pillar:first-child').find('.pillar__content').fadeIn(250, () => {
                this.$element.find('.pillar:first-child').addClass('is-active');
            });
            this.$element.find('.pillar:first-child').siblings().find('.pillar__content').fadeOut(250, () => {
                this.$element.find('.pillar:first-child').siblings().removeClass('is-active');
            });
        }
    }

    prev() {
        if (this.$element.find('.pillar.is-active').prev() && this.$element.find('.pillar.is-active').prev().length > 0) {
            const $active = this.$element.find('.pillar.is-active');
            $active.prev().find('.pillar__content').fadeIn(250, () => {
                $active.prev().addClass('is-active');
            });
            $active.prev().siblings().find('.pillar__content').fadeOut(250, () => {
                $active.prev().siblings().removeClass('is-active');
            });
        } else {
            this.$element.find('.pillar:last-child').find('.pillar__content').fadeIn(250, () => {
                this.$element.find('.pillar:last-child').addClass('is-active');
            });
            this.$element.find('.pillar:last-child').siblings().find('.pillar__content').fadeOut(250, () => {
                this.$element.find('.pillar:last-child').siblings().removeClass('is-active');
            });
        }
    }

    attachMobile() {

        this.setTextSize();

        this.$trigger.on('click', event => {
            $('.pillar').removeClass('is-active');

            $(event.currentTarget).closest('.pillar').addClass('is-active');
            this.$element.css('margin-bottom', $(event.currentTarget).parent().find('.pillar__content').outerHeight() + 150 + 'px');

            $('html, body').animate({
                scrollTop: $(event.currentTarget).parent().find('.pillar__content').offset().top - 60
            }, 250);
        });

        this.$close.on('click', event => {
            $(event.currentTarget).closest('.pillar').removeClass('is-active');
            this.$element.css('margin-bottom', 0);

            $('html, body').animate({
                scrollTop: this.$element.offset().top - 50
            }, 250);
        });

    }

    detachMobile() {

    }

    setTextSize() {
        let biggestHeight = 0;

        $.each($('.pillar__content'), (index, item) => {
            $(item).show();
            if ($(item).find('.pillar__text').height() > biggestHeight) {
                biggestHeight = $(item).find('.pillar__text').height();
            }
            $(item).hide();
        });

        $('.pillar__text').css('height', biggestHeight);
    }

}


// WEBPACK FOOTER //
// ./components/Pillars.js